
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryKeys } from "react-query/constant";
import { doctorListApi, sendScanApi } from "api/scanApi";

export const useDoctorList = () => {
    return useQuery([queryKeys.doctorList], doctorListApi, {
        refetchInterval: 30 * 1000
    });
};

export const useSendScan = () => {
    return useMutation({
        mutationFn: sendScanApi,
        onSuccess: (response, args) => {
            const { setSuccessfullySend, reportSucceed, registerNewUser, setOpen, activeDoctorId } = args;
            if (response === null || response === '') {
                registerNewUser(activeDoctorId);
                setOpen(false);
            } else {
                reportSucceed(response);
                setSuccessfullySend(true);
            }
        },
        onError: (err, args) => {
            console.log(err.response);
            const { setSuccessfullySend, reportFailed } = args;
            setSuccessfullySend(false);
            reportFailed();
        }
    });
};